<app-salary-pending-drafts />
<app-salary-external-systems />
<app-salary-settlement-bonuses />
<app-salary-summary />
